import { gql } from '@apollo/client';

// 인증 > 로그인
export const ADMIN_LOGIN = gql`
    mutation AdminLogin($account: String!, $password: String!) {
        adminLogin(account: $account, password: $password)
    }
`;
// 인증 > 이메일 찾기
export const FIND_ADMIN_ACCOUNT = gql`
    mutation FindAdminAccount($name: String!, $cellphone: String!) {
        findAdminAccount(name: $name, cellphone: $cellphone)
    }
`;
// 인증 > 비밀번호 찾기
export const FIND_ADMIN_PW = gql`
    mutation FindAdminPw(
        $account: String!
        $name: String!
        $cellphone: String!
    ) {
        findAdminPw(account: $account, name: $name, cellphone: $cellphone)
    }
`;
// 인증 > 비밀번호 변경(180일 경과)
export const UPDATE_ADMIN_PW = gql`
    mutation UpdateAdminPw($currentPw: String!, $updatePw: String!) {
        updateAdminPw(currentPw: $currentPw, updatePw: $updatePw)
    }
`;
// 인증 > 비밀번호 변경(최초 로그인, 초기화)
export const UPDATE_INIT_ADMIN_PW = gql`
    mutation UpdateInitAdminPw($password: String!, $passwordConfirm: String!) {
        updateInitAdminPw(
            password: $password
            passwordConfirm: $passwordConfirm
        )
    }
`;

// 회원 > 회원 정보 수정
export const UPDATE_USER_INFO = gql`
    mutation UpdateUserInfo(
        $userId: Int!
        $name: String!
        $cellphone: String!
        $email: String!
    ) {
        updateUserInfo(
            userId: $userId
            name: $name
            cellphone: $cellphone
            email: $email
        )
    }
`;
// 회원 > 회원 삭제
export const DELETE_USER = gql`
    mutation DeleteUser($userId: Int!) {
        deleteUser(userId: $userId)
    }
`;

// 운영 > QR 삭제
export const DELETE_PET_QR = gql`
    mutation DeletePetQr($qrId: Int!) {
        deletePetQr(qrId: $qrId)
    }
`;
// 운영 > 상품 생성
export const CREATE_PRODUCT = gql`
    mutation CreateProduct(
        $name: String!
        $url: String!
        $price: Int!
        $img: Upload
    ) {
        createProduct(name: $name, url: $url, price: $price, img: $img)
    }
`;
// 운영 > 상품 삭제
export const DELETE_PRODUCT = gql`
    mutation DeleteProduct($prId: Int!) {
        deleteProduct(prId: $prId)
    }
`;
// 운영 > 방침 생성
export const CREATE_POLICY = gql`
    mutation CreatePolicy(
        $type: Int!
        $require: Boolean!
        $title: String!
        $text: String!
    ) {
        createPolicy(type: $type, require: $require, title: $title, text: $text)
    }
`;

// 설정 > QR 생성
export const CREATE_PET_QR = gql`
    mutation CreatePetQR($amount: Int!) {
        createPetQR(amount: $amount)
    }
`;
// 설정 > 운영자 추가
export const CREATE_ADMIN = gql`
    mutation CreateAdmin(
        $account: String!
        $name: String!
        $cellphone: String!
        $rank: String
        $memo: String
    ) {
        createAdmin(
            account: $account
            name: $name
            cellphone: $cellphone
            rank: $rank
            memo: $memo
        )
    }
`;
// 설정 > 운영자 수정
export const UPDATE_ADMIN = gql`
    mutation UpdateAdmin(
        $adminId: Int!
        $account: String!
        $name: String!
        $cellphone: String!
        $rank: String
        $memo: String
    ) {
        updateAdmin(
            adminId: $adminId
            account: $account
            name: $name
            cellphone: $cellphone
            rank: $rank
            memo: $memo
        )
    }
`;
// 설정 > 운영자 추가
export const UPDATE_ADMIN_PERMISSION = gql`
    mutation UpdateAdminPermission(
        $apId: Int!
        $dashboard: Boolean!
        $userTab: Boolean!
        $product: Boolean!
        $management: Boolean!
    ) {
        updateAdminPermission(
            apId: $apId
            dashboard: $dashboard
            userTab: $userTab
            product: $product
            management: $management
        )
    }
`;
// 설정 > 운영자 비밀번호 초기화
export const INIT_ADMIN_PW = gql`
    mutation InitAdminPw($adminId: Int!) {
        initAdminPw(adminId: $adminId)
    }
`;
// 설정 > 운영자 삭제
export const DELETE_ADMIN = gql`
    mutation DeleteAdmin($adminId: Int!) {
        deleteAdmin(adminId: $adminId)
    }
`;

// TextEditor 이미지 업로드
export const UPLOAD_TEXT_IMG = gql`
    mutation UploadTextImg($imgs: [Upload]) {
        uploadTextImg(imgs: $imgs)
    }
`;
